(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/payfooter/assets/javascripts/payfooter.js') >= 0) return;  svs.modules.push('/components/app/payfooter/assets/javascripts/payfooter.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs = svs || {};
  svs.app = svs.app || {};
  svs.app.payfooter = svs.app.payfooter || {};

  svs.app.payfooter.PayFooter = Marionette.View.extend({
    template: function(data) {
      return svs.app.payfooter.templates.payfooter(data);
    },
    id: 'paymentfooter',
    className: 'payment-footer',

    events: {
      'click .js-btn-pay': 'onPayClick'
    },
    log: new svs.core.log.Logger('svs.app.payfooter.PayFooter'),

    initialize: function(options) {
      this.model = options.model;

      this.listenTo(this.model, 'change:price', this.renderText);
      this.listenTo(this.model, 'change', this.render);
      if (typeof this.model.pay === 'function') {
        this.onPayClick = this.model.pay;
      }
    },

    onPayClick: function() {
      this.log.info('No payment function supplied.');
    }
  });
})(Backbone, _, svs);

svs.events.publish('/payfooter/loaded');

 })(window);